import {decodeLoad} from './base64'

export class HypTools {
  constructor() {
    console.log('---------------HypTools----------- Constructor ')
  }

  checkJsonStr(str) {
    // console.log('CHECK JSON (%s)', str)
    if (str === undefined) {
      return ''
    }
    let s1 = str.replace('"', "'")
    let s2 = s1.replace('{', '')
    let s3 = s2.replace('}', '')
    let s4 = s3.replace('/[\u00A0\u1680​\u180e\u2000-\u2009\u200a​\u200b​\u202f\u205f​\u3000\u0009\u000D\u005C]/g', '')
    let s5 = s4.replace('[', '')
    let s6 = s5.replace(']', '')
    let s7 = s6.replace(/\n/g, ' ') // newlines
    let s8 = s7.replace(/\t/g, ' ') // tabulators
    let s9 = s8.replace('\\n', ' ') // tabulators
    let s10 = s9.replace('\\', '') // tabulators
    let s11 = s10.replace('  ', ' ') // double spaces
    return s11
  }

  checkWeek(str) {
    // console.log('CHECK JSON (%s)', str)
    if (str === undefined) {
      return ''
    }
    let s1 = str.replace('.', ',')
    let s2 = s1.replace(':', ',')
    let s3 = s2.replace(';', ',')
    let s4 = s3.replace('/[\u00A0\u1680​\u180e\u2000-\u2009\u200a​\u200b​\u202f\u205f​\u3000\u0009\u000D\u005C]/g', '')
    let s5 = s4.replace('-', ',')
    let s6 = s5.replace(' ', '')
    let s7 = s6.replace(',,', ',')
    return s7
  }

  asString(str) {
    if (this.isBase64(str)) {
      return decodeLoad(str)
    } else {
      return str
    }
  }

  /**
   * Checks if the given string is a valid base64 encoded string.
   *
   * @param {string} str - The string to check.
   * @returns {boolean} `true` if the string is a valid base64 encoded string, `false` otherwise.
   */
  isBase64(str) {
    // Check if the string is empty or null
    if (!str || str.trim() === '') {
      return false
    }

    // Check if the string starts with a base64 prefix
    /*
    if (str.startsWith('data:') || str.startsWith('base64,')) {
      return true;
    }
    */

    // Check if the string contains only valid base64 characters
    const base64Regex = /^[A-Za-z0-9+/=]+$/
    return base64Regex.test(str)
  }
}
